var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { Environment } from "../Infra/Environment";
export class StudyLinkDialogViewModel {
    constructor(opts) {
        this.bannerUIManager = opts.container.bannerUIManager;
        this.authManager = opts.container.authManager;
        this.study = opts.study;
        const env = new Environment();
        this.webAppBaseUrl = env.WEBAPP_BASE_URL;
    }
    get title() {
        return "Share patient experience with QR code or link";
    }
    get width() {
        return 444;
    }
    get initialConsentLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/${this.study.id}/enrollment/link`;
    }
    get initialConsentDownloadName() {
        return `initial-consent-${this.study.id}`;
    }
    get addRecordLocationLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/${this.study.id}/enrollment/link?addRecordLocationsDirectly=true`;
    }
    get addRecordLocationDownloadName() {
        return `add-record-location-${this.study.id}`;
    }
    get updateLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/${this.study.id}/data-update`;
    }
    get updateDownloadName() {
        return `data-update-${this.study.id}`;
    }
    get resumeLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/resume?studyId=${encodeURIComponent(this.study.id)}`;
    }
    get resumeDownloadName() {
        return `resume-${this.study.id}`;
    }
    async copyLink(link) {
        await navigator.clipboard.writeText(link);
        this.bannerUIManager.displayBanner({ text: "Link copied to clipboard" });
    }
}
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "title", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "width", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "initialConsentLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "initialConsentDownloadName", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "addRecordLocationLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "addRecordLocationDownloadName", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "updateLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "updateDownloadName", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "resumeLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "resumeDownloadName", null);
